<template>
	<lv-base-column
		ref="column" v-bind="columnBinding" :width="width!=null?width:datetime?130:90">

		<template slot-scope="{row,rowIndex,col,colIndex,editRow,fixedRow,}">
			<link-table-column-datepicker-item
				:row="row"
				:edit-row="editRow"
				:row-index="rowIndex"
				:col="col"
				:col-index="colIndex"
				:fixed-row="fixedRow"
				v-bind="columnItemBinding"
				@click="lv_clickItem"
				@change="e=>$emit('change',e)"

				:display-format="displayFormat"
				:value-format="valueFormat"
				:view="view"
				:no-confirm="noConfirm"
				:datetime="datetime"
				:max="max"
				:min="min"
			/>
		</template>
	</lv-base-column>
</template>

<script>
	import {ColumnMixin} from "../mixins";
	import LinkTableColumnDatepickerItem from "./link-table-column-datepicker-item";
	import LvBaseColumn from "../../table/lv-base-column";
	import {DateUtil} from "../../datetime/date";

	const format = (ctx, val) => {
		return LinkUtils.dateFormat(
			LinkUtils.dateParse(val, DateUtil.getDefaultValueFormat(ctx.valueFormat, ctx.datetime, ctx.view)),
			DateUtil.getDefaultDisplayFormat(ctx.displayFormat, ctx.datetime, ctx.view)
		)
	}

	export default {
		name: 'link-table-column-datepicker',
		components: {LvBaseColumn, LinkTableColumnDatepickerItem},
		mixins: [ColumnMixin],
		props: {
			filterName: {default: 'date'},
			width: {default: null},

			displayFormat: {type: String,},
			valueFormat: {type: String,},
			view: {default: 'date',},
			noConfirm: {type: Boolean, default: true},
			datetime: {type: Boolean, default: false},
			max: {type: String,},
			min: {type: String,},

			formatter: {
				default() {
					return val => format(this, val)
				},
			},
			translate: {
				default() {
					return val => format(this, val)
				},
			},
		},
	};
</script>
